import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiFormatListBulleted } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const TasksMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (!user.equinor) {
      return null;
    }

    if (
      !(
        user.roles_names.includes("View Vbuyer Tasks") ||
        user.roles_names.includes("Vbuyer - View Quotation Approval") ||
        user.roles_names.includes("Edit All Vendors") ||
        user.roles_names.includes(
          "Request Anticipation Evaluation Quotation - View",
        )
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="tasks"
          onClick={() => handleClick("tasks")}
          title={t("menu.tasks.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiFormatListBulleted} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.tasks.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon icon={openSubmenu.tasks ? mdiChevronUp : mdiChevronDown} />
        </ListItemButton>
        <Collapse in={openSubmenu.tasks} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {user.roles_names.includes("View Vbuyer Tasks") && (
              <HybridRouteListItemButtonLink
                caption="tasks open"
                isReact={false}
                name="tasks[open]"
                sx={{ pl: 4 }}
                title={t("menu.tasks.submenu.open.title")}
                url="/vbuyer/human_tasks/open"
              >
                <ListItemText
                  primary={t("menu.tasks.submenu.open.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes("Vbuyer - View Quotation Approval") && (
              <HybridRouteListItemButtonLink
                caption="tasks quotation approval"
                isReact={false}
                name="tasks[quotationApproval]"
                sx={{ pl: 4 }}
                title={t("menu.tasks.submenu.quotationApproval.title")}
                url="/vbuyer/human_tasks/quotation_approval"
              >
                <ListItemText
                  primary={t("menu.tasks.submenu.quotationApproval.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {user.roles_names.includes(
              "Request Anticipation Evaluation Quotation - View",
            ) && (
              <HybridRouteListItemButtonLink
                caption="tasks request anticipation evaluation quotation"
                name="tasks[requestAnticipationEvaluationQuotation]"
                sx={{ pl: 4 }}
                title={t(
                  "menu.tasks.submenu.requestAnticipationEvaluationQuotation.title",
                )}
                url="/request_anticipation_evaluation_quotations"
              >
                <ListItemText
                  primary={t(
                    "menu.tasks.submenu.requestAnticipationEvaluationQuotation.title",
                  )}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
